import { createFileRoute } from "@tanstack/react-router";

import { PlatformPage } from "@/features/platform/components/platform-chrome";
import { PlatformContact } from "@/features/platform/modules/contact/platform-contact";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/contact/")({
  head: () => ({
    meta: pageMeta({ title: m.seo_contact_title(), description: m.seo_contact_description() }),
  }),
  loader: () => ({ crumb: m.landing_nav_contact() }),
  component: ContactPage,
});

/** How to reach the people who run the platform, as opposed to a trainer on it. */
function ContactPage() {
  return (
    <PlatformPage>
      <PlatformContact lead />
    </PlatformPage>
  );
}
